import { render, staticRenderFns } from "./FormaRecebimentoCadastroModal.vue?vue&type=template&id=5564816a&scoped=true"
import script from "./FormaRecebimentoCadastroModal.vue?vue&type=script&lang=js"
export * from "./FormaRecebimentoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimentoCadastroModal.vue?vue&type=style&index=0&id=5564816a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564816a",
  null
  
)

export default component.exports